import { AffiliateRepresentationType } from '@/interfaces/affiliates';
import { queryRepresentativesTypes } from '@/services/representatives.service';
import { Effect, Reducer } from '@umijs/max';

export interface ModelType {
  namespace: string;
  state: { representativesTypes: AffiliateRepresentationType[] };
  effects: {
    fetchAffiliateRepresentativesTypes: Effect;
  };
  reducers: {
    setRepresentativesTypes: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'representantsList',

  state: {
    representativesTypes: [],
  },

  effects: {
    *fetchAffiliateRepresentativesTypes({ payload }, { call, put, all }) {
      const [representativesTypes] = yield all([call(queryRepresentativesTypes, payload)]);

      yield put({
        type: 'setRepresentativesTypes',
        payload: { representativesTypes: representativesTypes.data },
      });
    },
  },

  reducers: {
    setRepresentativesTypes(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
